import graphql from './graphql';

const mutation = /* GraphQL */ `
  mutation Module_singleUpdate($moduleData: ModuleData) {
    Module_singleUpdate(moduleData: $moduleData) {
      value
    }
  }
`;

const moduleSingleUpdate = async moduleData =>
  graphql(mutation, { moduleData }).then(
    // eslint-disable-next-line camelcase
    ({ Module_singleUpdate }) => Module_singleUpdate
  );

export default moduleSingleUpdate;
